/**
 * レザノベ 見積フォーム流入元・訪問履歴トラッキング
 * - 初回訪問情報 / UTM / 訪問回数 / 直前ページ / 直前の商品・LPページ を
 *   localStorage・sessionStorageに保存し、フォーム送信直前にhidden inputへ注入する。
 */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'lezanobe_';
  var SESSION_GAP_MS = 30 * 60 * 1000; // 30分
  var FORM_PATH_PATTERNS = ['/pages/est', 'contact', 'inquiry', 'estimate'];
  var PRODUCT_OR_LP_PATTERNS = ['/products/', '/pages/', '/collections/'];

  var keys = {
    firstLanding: STORAGE_PREFIX + 'first_landing_page_url',
    firstReferrer: STORAGE_PREFIX + 'first_referrer',
    firstVisit: STORAGE_PREFIX + 'first_visit_datetime',
    lastVisit: STORAGE_PREFIX + 'last_visit_datetime',
    visitCount: STORAGE_PREFIX + 'visit_count',
    lastProductOrLp: STORAGE_PREFIX + 'last_product_or_lp_url',
    currentUrl: STORAGE_PREFIX + 'current_page_url',
    previousUrl: STORAGE_PREFIX + 'previous_page_url'
  };

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  var HIDDEN_FIELD_NAMES = [
    'current_page_url',
    'previous_page_url',
    'first_landing_page_url',
    'first_referrer',
    'current_referrer',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'visit_count',
    'first_visit_datetime',
    'last_product_or_lp_url'
  ];

  function isDebugEnabled() {
    try {
      return localStorage.getItem(STORAGE_PREFIX + 'debug') === '1';
    } catch (e) {
      return false;
    }
  }

  function debugLog(values) {
    if (isDebugEnabled() && window.console && typeof console.table === 'function') {
      console.table(values);
    }
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function safeGet(storage, key) {
    try {
      return storage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value || '');
    } catch (e) {
      /* storageが利用できない環境(プライベートモード等)では何もしない */
    }
  }

  function isFormPath(pathname) {
    for (var i = 0; i < FORM_PATH_PATTERNS.length; i++) {
      if (pathname.indexOf(FORM_PATH_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function initFirstVisit() {
    if (!safeGet(localStorage, keys.firstLanding)) {
      safeSet(localStorage, keys.firstLanding, location.href);
    }
    if (!safeGet(localStorage, keys.firstReferrer)) {
      safeSet(localStorage, keys.firstReferrer, document.referrer || 'direct');
    }
    if (!safeGet(localStorage, keys.firstVisit)) {
      safeSet(localStorage, keys.firstVisit, nowIso());
    }
  }

  function updateVisitCount() {
    var lastVisit = safeGet(localStorage, keys.lastVisit);
    var currentTime = Date.now();
    var shouldCount = true;

    if (lastVisit) {
      var lastTime = new Date(lastVisit).getTime();
      if (!isNaN(lastTime) && currentTime - lastTime < SESSION_GAP_MS) {
        shouldCount = false;
      }
    }

    if (shouldCount) {
      var currentCount = parseInt(safeGet(localStorage, keys.visitCount) || '0', 10);
      if (isNaN(currentCount)) currentCount = 0;
      safeSet(localStorage, keys.visitCount, String(currentCount + 1));
    }

    safeSet(localStorage, keys.lastVisit, nowIso());
  }

  function updateUtmParams() {
    var params = new URLSearchParams(location.search);
    UTM_KEYS.forEach(function (utmKey) {
      var value = params.get(utmKey);
      if (value) {
        safeSet(localStorage, STORAGE_PREFIX + utmKey, value);
      }
    });
  }

  function updatePageHistory() {
    var previous = safeGet(sessionStorage, keys.currentUrl);
    if (previous && previous !== location.href) {
      safeSet(sessionStorage, keys.previousUrl, previous);
    }
    safeSet(sessionStorage, keys.currentUrl, location.href);
  }

  function updateLastProductOrLp() {
    var path = location.pathname;
    var isTargetPage = false;
    for (var i = 0; i < PRODUCT_OR_LP_PATTERNS.length; i++) {
      if (path.indexOf(PRODUCT_OR_LP_PATTERNS[i]) !== -1) {
        isTargetPage = true;
        break;
      }
    }
    if (isTargetPage && !isFormPath(path)) {
      safeSet(localStorage, keys.lastProductOrLp, location.href);
    }
  }

  function getTrackingValues() {
    var values = {
      current_page_url: location.href,
      previous_page_url: safeGet(sessionStorage, keys.previousUrl),
      first_landing_page_url: safeGet(localStorage, keys.firstLanding),
      first_referrer: safeGet(localStorage, keys.firstReferrer),
      current_referrer: document.referrer || 'direct',
      visit_count: safeGet(localStorage, keys.visitCount),
      first_visit_datetime: safeGet(localStorage, keys.firstVisit),
      last_product_or_lp_url: safeGet(localStorage, keys.lastProductOrLp)
    };
    UTM_KEYS.forEach(function (utmKey) {
      values[utmKey] = safeGet(localStorage, STORAGE_PREFIX + utmKey);
    });
    return values;
  }

  function upsertHiddenInput(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value || '';
  }

  function injectTrackingFields(form) {
    var values = getTrackingValues();
    HIDDEN_FIELD_NAMES.forEach(function (name) {
      upsertHiddenInput(form, name, values[name]);
    });
    debugLog(values);
    return values;
  }

  function bindForms() {
    // submitイベントをキャプチャフェーズで拾い、各フォーム固有の送信処理より先にhidden項目を確定させる。
    // 動的に描画されたフォームにも対応できるよう、DOMContentLoaded後の一括バインドではなくイベント委譲にする。
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;
        injectTrackingFields(form);
      },
      true
    );
  }

  function populateExistingHiddenFields() {
    // ページ表示時点でも値を入れておく（JS実行後に手動で送信ボタンを押すだけのケースに備える）
    var forms = document.querySelectorAll('form');
    forms.forEach(function (form) {
      var hasTrackingField = HIDDEN_FIELD_NAMES.some(function (name) {
        return !!form.querySelector('input[name="' + name + '"]');
      });
      if (hasTrackingField) {
        injectTrackingFields(form);
      }
    });
  }

  function init() {
    initFirstVisit();
    updateVisitCount();
    updateUtmParams();
    updateLastProductOrLp();
    updatePageHistory();
    bindForms();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', populateExistingHiddenFields);
    } else {
      populateExistingHiddenFields();
    }
  }

  window.LezanobeTracking = { getTrackingValues: getTrackingValues };

  init();
})();
